import { saveAs } from "file-saver";
import CsharpEnum from "@/_helpers/CsharpEnum";
import ModuleTypeHelper from "./ModuleTypeHelper";
import {
  constructChartSeriesHeaderForTable,
  constructChartSeriesDataForTable,
} from "./widgetHelper";
import { isDate } from "lodash-es";

export default {
  methods: {
    validFileName(filename) {
      return (
        filename !== undefined &&
        typeof filename === "string" &&
        filename.length > 0
      );
    },

    exportTableAsCSV(headers, data, filename) {
      const csvRows = [];
      csvRows.push(
        headers
          .filter(() => true) // To create a copy
          .sort((a, b) => a.value.toString().localeCompare(b.value.toString())) // Sort the headers based on value to make Object.values(row) line up correctly with the header
          .map((x) => x.text ?? x.name ?? x)
          .join(","),
      );
      for (var row of data) {
        csvRows.push(
          Object.values(row)
            .map((x) => (isDate(x) ? this.toISOStringKeepTimezoneOffset(x) : x))
            .join(","),
        );
      }
      if (csvRows.length < 2) {
        console.error("No table headers or data to be exported");
        return;
      }
      saveAs(
        new Blob([csvRows.join("\n")], { type: "text/csv" }),
        this.validFileName(filename) ? `${filename}.csv` : `Table.csv`,
      );
    },

    exportTableAsJson(headers, data, filename, useMappingValues = false) {
      // If useMappingValues: Creates the Json from the raw headers and data.
      // Else: Modifies the json to have the text value of the header (What you see in the table header)
      // instead of the datas mapping value, as keys in data.

      const lookupHeader = {};
      if (!useMappingValues)
        headers.forEach((x) => (lookupHeader[x.value] = x.text));

      const jsonString = JSON.stringify({
        headers: useMappingValues ? headers : headers.map((x) => x.text),
        data: data.map((x) => {
          const res = {};
          for (var key of Object.keys(x)) {
            const name = lookupHeader[key] ?? key;
            res[name] = isDate(x[key])
              ? this.toISOStringKeepTimezoneOffset(x[key])
              : x[key];
          }
          return res;
        }),
      });

      if (jsonString === "" || jsonString === "{}") {
        console.error("No table headers or data to be exported");
        return;
      }

      saveAs(
        new Blob([jsonString], { type: "application/json" }),
        this.validFileName(filename) ? `${filename}.json` : `Table.json`,
      );
    },

    exportWidgetEchartAsPng(widgetType, filename, filetype = "png") {
      // Needs a ref="echart" on the echart component
      const echart = this.$refs.echart;
      if (echart == undefined) {
        console.error("No ref on the widget");
        return;
      }

      const dataURL = echart.getDataURL({
        type: filetype, // can be jpeg or png
        pixelRatio: 2, // image's ratio.
        backgroundColor: "#fff", // hex color defining the background of the chart
      });
      saveAs(
        dataURL,
        `${
          this.validFileName(filename)
            ? filename
            : ModuleTypeHelper.widgetTypes().find((x) => x.value == widgetType)
                ?.name ?? "Image"
        }.${filetype}`,
      );
    },

    exportWidgetAsCSV(series, widgetType) {
      let header = [];
      let data = [];
      let filename = undefined;

      switch (widgetType) {
        case CsharpEnum.ModuleType.MULTICHART:
          header = constructChartSeriesHeaderForTable(series, true);
          data = constructChartSeriesDataForTable(series);
          filename = "ChartData";
          break;

        default:
          console.error(
            "CSV export of selected widget type is not implemented yet",
          );
          return;
      }

      this.exportTableAsCSV(header, data, filename);
    },

    exportWidgetAsJson(series, widgetType) {
      let header = [];
      let data = [];
      let filename = undefined;
      switch (widgetType) {
        case CsharpEnum.ModuleType.MULTICHART:
          header = constructChartSeriesHeaderForTable(series, true);
          data = constructChartSeriesDataForTable(series);
          filename = "ChartData";
          break;

        default:
          console.error(
            "Json export of selected widget type is not implemented yet",
          );
          return;
      }

      this.exportTableAsJson(header, data, filename);
    },
  },
};
